import React from 'react';
import FloatingBlob from './FloatingBlob';

// Bolder, more-present blobs: higher color opacity + reduced blur than before.
const FloatingBlobBackground = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden">
    <FloatingBlob
      blur="blur-xl"
      className="bg-[#004225]/50 w-[28rem] h-[28rem] -top-16 -left-10"
    />
    <FloatingBlob
      blur="blur-lg"
      className="bg-[#0a5c38]/45 w-80 h-80 top-40 right-0 animation-delay-2000 animate-blob-slow"
    />
    <FloatingBlob
      blur="blur-xl"
      className="bg-[#004225]/40 w-[32rem] h-[32rem] bottom-0 left-1/3 animation-delay-4000"
    />
    <FloatingBlob
      blur="blur-lg"
      className="bg-[#0a5c38]/40 w-72 h-72 bottom-24 right-1/4 animate-blob-slow"
    />
  </div>
);

export default FloatingBlobBackground;
